module.exports = __webpack_public_path__ + "static/media/MASK.5c513aab.svg";